import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

// Firebase project configuration using environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "admin.roundtown.in",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "menucard-4c570",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "menucard-4c570.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "124642119572",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:124642119572:web:b1ab207b151bf8d7f7c981",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-M62S43S6QF",
};

// Initialize Firebase app and services
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Explicitly set auth persistence to local (persists across page refreshes)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Auth persistence set to local');
  })
  .catch((error) => {
    console.error('Error setting auth persistence:', error);
  });

export { db, storage, app, auth, analytics };